import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import ResourcesCounter from "Components/resourcesCounter/ResourcesCounter";
import s from "./dashboard.scss";
import QboxmailApi from "../../../qboxmailApi";
import Loader from "Components/loader/Loader";
import ServiceIntro from "Components/serviceIntro/ServiceIntro";
import AdminDeliveryDashboard from "Components/adminDeliveryDashboard/AdminDeliveryDashboard";
import { DeliveryIntro, emailDelivery } from "../../../icons";
import { t } from "i18next";
import { AuthContext } from "@/App";

const api = new QboxmailApi({ useCookie: true });

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const { getLoggedUser } = useContext(AuthContext);

  const getStats = async () => {
    try {
      const resp = await api.getDeliveryDashboard();
      setStats(resp);
      console.log("ressssppp", resp);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  const loggedUser = getLoggedUser();

  return (
    <div className={s.dashboardContainer}>
      <div className={s.container}>
        <ServiceIntro
          iconSvg={emailDelivery}
          title={t("delivery.intro.title")}
          description={t("delivery.intro.description")}
          imageSvg={DeliveryIntro}
        />

        <div className="sectionTitle">Dashboard</div>
        <div className={s.content}>{stats ? <ResourcesCounter summary={stats || {}} /> : <Loader />}</div>

        {loggedUser.type === "Admin" && (
          <div className="w-full pt-10">
            <div className="mb-4 sectionTitle">Invii per giorno</div>
            <AdminDeliveryDashboard />
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
